var Chart = require('chart.js');

var chartConfig = {
	type: 'bar',
	data: {
		labels: ["sept.", "", "", "", "oct.", "", "", "", "nov.", "", "", "", "dic.", "", "", "", "en.", "", "", "", "feb.", "", "", "", "mar.", "", "", "", "abr.", "", "", "", "", "may.", "", "", "", "jun.", "", "", "", "jul.", "", "", "", "ago.", "", "", "",],
		datasets: [{
			label: 'Servicios',
			backgroundColor: "rgba(79, 154, 230, 0.5)",
			hoverBackgroundColor: "rgba(79, 154, 230, 1)",
			data: [275, 250, 340, 480, 530, 425, 300, 370, 490, 575, 580, 525, 550, 510, 310, 390, 450, 480, 460, 520, 420, 430, 300, 340, 290, 310, 350, 420, 490, 510, 530, 545, 480, 470, 370, 280, 490, 575, 580, 525, 300, 340, 290, 310, 340, 480, 530, 325, 280,],
		}, {
			label: 'Productos',
			backgroundColor: "rgba(226, 134, 48, 0.5)",
			hoverBackgroundColor: "rgba(226, 134, 48, 1)",
			data: [0, 30, 0, 105, 0, 85, 0, 0, 60, 45, 0, 0, 45, 70, 0, 0, 0, 0, 140, 25, 30, 0, 90, 0, 40, 0, 130, 180, 45, 0, 0, 35, 40, 0, 0, 80, 0, 45, 75, 25, 30, 0, 90, 0, 40, 0, 0, 150],
		}, {
			label: 'Bonos',
			backgroundColor: "rgba(188, 188, 188, 0.5)",
			hoverBackgroundColor: "rgba(188, 188, 188, 1)",
			data: [45, 0, 0, 45, 20, 0, 0, 45, 0, 0, 85, 10, 0, 0, 45, 0, 30, 0, 60, 0, 75, 20, 0, 0, 45, 0, 0, 55, 40, 0, 0, 45, 0, 0, 75, 20, 0, 0, 60, 0, 75, 20, 0, 0, 45, 0, 0, 45, 20, 0,],
		}],
	},
	options: {
		tooltips: {
			mode: 'index',
			intersect: false,
			backgroundColor: '#fff',
			bodyFontColor: '#404040',
			bodyFontSize: resizer(16),
			bodySpacing: 3,
			xPadding: 9,
			yPadding: 9,
			borderColor: 'rgba(0,0,0,0.1)',
			borderWidth: 1,
			callbacks: {
				title: function (t, d) {
					return null;
				}
			}
		},
		scales: {
			xAxes: [{
				stacked: true,
				gridLines: {
					display: false,
				},
				ticks: {
					fontSize: resizer(17),
					fontColor: 'rgba(64, 64, 64, 0.5)',
				}
			}],
			yAxes: [{
				stacked: true,
				ticks: {
					fontSize: resizer(17),
					fontColor: 'rgba(64, 64, 64, 0.5)',
					beginAtZero: true,
					callback: function (value, index, values) {
						return value + '€';
					}
				},
				type: 'linear',
			}]
		},
		responsive: true,
		maintainAspectRatio: false,
		legend: {
			position: 'bottom',
			labels: {
				fontSize: resizer(24),
				padding: resizer(30),
			}
		},
	}
};

window.addEventListener('load', function () {
	var ctx = document.getElementById("chart").getContext('2d');
	var myChart = new Chart(ctx, chartConfig);
});

Chart.Legend.prototype.afterFit = function () {
	this.height = this.height + 50;
};

function resizer(number) {
	var wWidth = window.innerWidth;

	if (wWidth < 1900) {
		return (wWidth / 1900) * number;
	} else {
		return number;
	}
}
